import angular from 'angular';
import uiRouter from 'angular-ui-router';
import notificationComponent from './notification.component';
import notificationListComponent from './notification-list.component';
import notificationDetailComponent from './notification-detail.component';
import notificationService from './notification.service';

let notificationModule = angular.module('notification', [
  uiRouter
])

.service('Notification', notificationService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/notification');

  $stateProvider
    .state('notification', {
      component: 'notification'
    })
    .state('notification.list', {
      url: '/notification',
      component: 'notificationList'
    })
    .state('notification.create', {
      url: '/notification/new',
      component: 'notificationDetail',
      params: {
      	id: ""
      }
    })
    .state('notification.detail', {
      url: '/notification/:id/detail',
      component: 'notificationDetail',
      params: {
        id: ""
      }
    });
})

.component('notification', notificationComponent)
.component('notificationList', notificationListComponent)
.component('notificationDetail', notificationDetailComponent)

.name;

export default notificationModule;



// WEBPACK FOOTER //
// ./client/app/components/notification/notification.js